// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const fr: ChromeTranslations = {
  'nav.nextPage': 'page suivante →',
  'nav.previousPage': '← page précédente',
  'nav.continueToLevel': 'continuer vers le niveau →',
  'nav.backToMenu': 'retour au menu →',
  'howto.page': 'page {n} sur {total}',
  'options.title': 'Options',
  'ui.language': 'Langue',
};
